import React, { useContext } from "react"
import * as Yup from "yup"
import { IChooseTypeExportModel } from "./models"
import { Form, Formik, FormikHelpers } from "formik"
import MyAlert from "@common-utils/MyAlert"
import MySimpleSpinner from "@common-utils/MySimpleSpinner"
import MySelectFormField from "@common-components/fields/MySelectFormField"
import { ExportHierarchyContext } from "./Exports"

const ExportSelectType = () => {
     const context = useContext(ExportHierarchyContext)

     const schema = Yup.object().shape({
          type: Yup.string().label("`Type`").required(),
     })

     const initialValues: IChooseTypeExportModel = {}

     function handleSubmit(values: IChooseTypeExportModel, helpers: FormikHelpers<IChooseTypeExportModel>) {
          helpers.setStatus(null)

          context.setSelectedType(values.type!)
     }

     return (
          <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={schema}>
               {helpers => {
                    return (
                         <Form noValidate autoComplete="off">
                              {helpers.status && (
                                   <MyAlert type={"danger"} classNames={"mb-4"}>
                                        {helpers.status}
                                   </MyAlert>
                              )}

                              <MySelectFormField
                                   label={"Choisissez le type"}
                                   name={"type"}
                                   formikProps={helpers}
                                   validationSchema={schema}
                                   options={[
                                        { label: "Assurance", value: "ASSURANCE" },
                                        { label: "Prime Hiérarchie", value: "HIERARCHY" },
                                        { label: "Turnover par consultant", value: "CA_FORFAIT_AT" },
                                   ]}
                                   placeholder={"Choisissez un type d'export"}
                                   classNameLabel={"col-lg-4"}
                                   classNameField={"col-lg-8"}
                              />

                              <div className="separator bg-primary my-5" />

                              {/* Submit button */}
                              <div className={"d-flex justify-content-end"}>
                                   <button className={"btn btn-sm btn-primary d-inline-flex align-items-center"} type={"submit"} disabled={helpers.isSubmitting}>
                                        {!helpers.isSubmitting ? (
                                             <>
                                                  Suivant <span className={"fas fa-angle-right fs-4 ms-2"} />
                                             </>
                                        ) : (
                                             <MySimpleSpinner size={"sm"} />
                                        )}
                                   </button>
                              </div>
                         </Form>
                    )
               }}
          </Formik>
     )
}

export default ExportSelectType
